<template>

<core-panel>

	<template v-slot:head>

		<h1>Shared DNA</h1>

		<p>All <b>{{ games.length }}</b> games sharing attributes with this one.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in games" :item="gameData(item.id)" :key="index" :subtext="subtext(item)" v-on:click.native="goToGame(item.id)">

			<span class="dna-overlap">{{ item.overlap }}/{{ item.total }}</span>

		</app-game>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'affinity',
			games: []
		}

	},

	methods: {

		response: function(json) {

			this.games = json.affinity.dna

		},

		gameData: function(id) {

			return this.$store.getters['data/games/associated'][id] || {}

		},

		goToGame: function(id) {

			this.$router.push({ name: 'InsightsGame', params: { game: id } })
			this.$pubsub.$emit('panel.close')

		},

		subtext: function(item) {

			return item.shared.join(', ')

		}

	}

}

</script>

<style scoped>

.dna-overlap {
	font-size: 14px;
	font-weight: 700;
	color: #4881bb;
	margin-left: 8px;
	flex-shrink: 0;
}

</style>
